var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 164.1 164.1",
    style: {
      enableBackground: "new 0 0 164.1 164.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#203162;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_113_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st0",
    d: "M82.1,164.1C36.8,164.1,0,127.3,0,82.1S36.8,0,82.1,0s82.1,36.8,82.1,82.1 S127.3,164.1,82.1,164.1z M82.1,4C39,4,4,39,4,82.1c0,43,35,78.1,78.1,78.1c43,0,78.1-35,78.1-78.1C160.1,39,125.1,4,82.1,4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_103_",
    className: "st0",
    d: "M44.1,108.8c6.7-2,13.5-4.1,20.3-6.2c-5.4-4.1-9.9-7.5-14.4-10.9c0.3-0.6,0.6-1.1,0.9-1.7 c1.4-0.3,2.8-0.6,5.4-1.1c-6.9-3.6-11.3-8-11.7-15.8c1.9,0.3,3.5,0.6,6.1,1.1c-5.5-6.6-8-13.1-3.9-21.3c9.2,9.3,19.5,16,33,16.4 c0.7-3.2,1-6.5,2.1-9.4c3.4-9,14.1-13.7,22-8.7c5.1,3.2,9.2,3.1,14.8,1.2c-1.4,2.1-2.8,4.2-4.6,6.8c2.3-0.4,4.2-0.8,6.1-1.1 c-7.1,4.9-6.3,12.8-7.9,19.8C103.8,113.8,66.5,122.4,44.1,108.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwF);
export default __webpack_public_path__ + "static/media/tw_f.1a2bbf495aa8b66d7205f394d3207446.svg";
export { ForwardRef as ReactComponent };